<template>
    <section>
        <span class="players-display">Players: {{ playersInGame }}/{{ playersSelected }}</span>
        <button class="button--settings" @click="settings = !settings"><i class="fas fa-cog"></i> settings</button>
        <div class="settings" :class="{'settings--hidden' : !settings }">
            <div class="players">
                <span>Players: </span>
                <label v-for="(count, index) in playersOptions" class="player" :class="{ 'player--active': playerActive(count)}" :key="index">
                    <input type="radio" name="players" :value=count v-model="playersSelected">
                    {{ count }}
                </label>
            </div>
            <!-- <p>
                <label>
                    <input type="checkbox" name="suddendeath" v-model="suddenDeath">
                    Sudden Death
                </label>
            </p> -->

            <div v-if="lastMove && debug">
                <p>Currently playing: {{ playersInGame }} players</p>
                <ul >
                    <li v-for="(placement, key) in extremities" :key="key" v-if="placement">{{ key }} on <span :class="[placement]">{{ placement }}</span></li>
                </ul>
            </div>

        </div>

        <div class="action" :class="{'action--faded': !action}">
            <template v-if="!lastMove">{{ message }}</template>
            <template v-else>Place {{ lastExtremity }} on <span class="color" :class="lastColor">{{ lastColor }}</span></template>
            <div v-if="suddenDeath">Sudden Death: Drop players!</div>
            <div v-if="gameOver">GAME OVER!</div>
        </div>
        
        <div class="buttons">
            <button @click="reset"><i class="fas fa-undo-alt"></i> restart</button>
            <button @click="removeUser" :disabled="!suddenDeath"><i class="fas fa-user-times"></i> drop player</button>
            <button @click="twist" class="button--twist" :disabled="gameOver || suddenDeath"><i class="far fa-compass"></i> twist</button>
        </div>
        
    </section>
</template>

<script>
export default {
    name: 'twister',
    data() {
        return {
            playersOptions: [2, 3, 4],
            playersSelected: 2,
            playersInGame: 2,
            settings: false,
            extremities: {
                'left hand': null,
                'right hand': null,
                'left foot': null,
                'right foot': null
            },
            colors: ['red', 'blue', 'green', 'yellow'],
            lastExtremity: false,
            lastColor: false,
            suddenDeath: false,
            gameOver: false,
            // action: true,
            lastStart: 0,
            debug: false
        };
    },
    computed: {
        message() {
            return this.lastMove || `get ready! (${this.playersInGame} players)`;
        },
        lastMove() {
            if (!this.lastExtremity || !this.lastColor) {
                return false;
            }
            return `place ${this.lastExtremity} on ${this.lastColor}`;
        },
        action() {
            return Date.now() - this.lastStart > 500;
        }
    },
    methods: {
        playerActive(player) {
            return this.playersInGame === player;
        },
        reset() {
            for (let extremity in this.extremities) {
                this.extremities[extremity] = null;
            }
            this.playersInGame = this.playersSelected;
            this.lastExtremity = false;
            this.lastColor = false;
            this.suddenDeath = false;
            this.gameOver = false;
        },
        twist() {
            const extremity = this.getRandomExtremity();
            const color = this.getRandomColor();

            this.placeIt(extremity, color);
        },
        placeIt(extremity, color) {
            if (this.isExtremityOnColor(extremity, color)) {
                console.log(`${extremity} already on ${color}`);
                this.twist();
            } else if (!this.isColorFree(color)) {
                console.log(`no more space on ${color}`);
                this.lastExtremity = extremity;
                this.lastColor = color;
                this.extremities[extremity] = color;

                if (this.playersInGame > 2) {
                    this.suddenDeath = true;
                } else {
                    // this.gameOver = true;
                    this.twist();
                }
            } else {
                console.log(`place ${extremity} on ${color}`);
                this.lastExtremity = extremity;
                this.lastColor = color;
                this.extremities[extremity] = color;
            }
        },
        removeUser() {
            if (this.playersInGame > 2) {
                this.playersInGame = this.playersInGame - 1;
                if (this.isColorFree(this.lastColor)) {
                    this.suddenDeath = false;
                }
            } else {
                this.gameOver = true;
            }
        },
        isExtremityOnColor(extremity, color) {
            return this.extremities[extremity] === color;
        },
        isColorFree(color) {
            const occurencies = Object.values(this.extremities).filter(c => c === color).length;
            const fieldsUsed = occurencies * this.playersInGame;
            return 6 - fieldsUsed >= this.playersInGame;
        },
        fader() {
            this.action = false;
            setTimeout(() => {
                this.action = true;
            }, 500);
        },
        getRandomExtremity() {
            const keys = Object.keys(this.extremities);
            return keys[ keys.length * Math.random() << 0 ];
        },
        getRandomColor() {
            return this.colors[Math.floor(Math.random() * this.colors.length)];
        }
    },
    watch: {
        playersSelected() {
            this.reset();
        }
    }
};
</script>

<style lang="scss" scoped>
    button {
        display: block;
        text-align: center;
        padding: 0.5rem;
        border: 1px solid #ccc;
        background-color: rgb(128, 128, 128);
        color: white;
        border-radius: 0.5em;

        &:disabled {
            opacity: 0.2;
        }
    }

    .button--settings {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        z-index: 1;
    }

    .button--twist {
        background-color: rebeccapurple;
    }

    .players-display {
        padding: 0.5rem;
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        z-index: 1;
        color:#ddd;
    }

    .settings {
        background-color:lightgrey; 
        padding: 0.5rem;
        border: 1px solid #ccc;
        border-radius: 0.5em;
        transition: all 0.2s ease-in-out;
        position: absolute;
        top: 4rem;
        right: 0.5rem;
    }

    .settings--hidden {
        transform: translateY( calc(-100% - 4rem) );
    }

    .players {
        display: flex;
    }

    .players > * {
        margin-left: 1em;
        margin-bottom: 0;

        &:first-child {
            margin-left: 0;
        }
    }

    .action {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: 700;
        font-size: calc(1rem + 1vw);
        text-align: center;
        width: calc(100% - 1rem);
        color:#ddd;
        transition: 500ms opacity ease-in-out;
    }

    .action--faded {
        opacity: 0;
    }

    .buttons {
        position: absolute;
        bottom: 0.5rem;
        left: 0.5rem;
        right: 0.5rem;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0.5rem;
    }

    .color {
        color: white;
        padding: 0.5rem;
        border-radius: 0.5em;
    }

    .red {
        background-color: #C1212B;
    }
    .green {
        background-color: #75A426;
    }
    .blue {
        background-color: #2C91DB;
    }
    .yellow {
        background-color: #E3DA19;
        color: black;
    }
</style>



// WEBPACK FOOTER //
// src/components/twister.vue